import { render, staticRenderFns } from "./barCode.vue?vue&type=template&id=a2eaef54"
import script from "./barCode.vue?vue&type=script&lang=js"
export * from "./barCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "barCode.vue"
export default component.exports